import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LockIcon from '@mui/icons-material/Lock';
import TwitterIcon from '@mui/icons-material/Twitter';
import GlowCard from '../../../shared/GlowCard';
import { useColors } from '../../../theme/ColorModeContext';
import { WEB3PWN_X_URL } from '../../../shared/brand';

const FOLLOW_KEY = 'web3pwn_followed_x';

export const hasFollowedX = () => {
    try {
        return localStorage.getItem(FOLLOW_KEY) === 'true';
    } catch {
        return false;
    }
};

interface PropsFollowGate {
    children: React.ReactNode;
}

// Honor-system unlock: X's API doesn't expose follow-relationship checks
// without paid elevated access, so this just records a client-side flag
// once the user clicks through to the profile.
const FollowGate = ({ children }: PropsFollowGate) => {
    const colors = useColors();
    const [unlocked, setUnlocked] = useState(hasFollowedX());

    const handleFollow = () => {
        window.open(WEB3PWN_X_URL, '_blank', 'noopener,noreferrer');
        try {
            localStorage.setItem(FOLLOW_KEY, 'true');
        } catch {
            // localStorage unavailable: unlock for this session only
        }
        setUnlocked(true);
    };

    if (unlocked) return <>{children}</>;

    return (
        <GlowCard gradientBorder sx={{ mb: '24px' }}>
            <Box sx={{ p: '32px', textAlign: 'center' }}>
                <LockIcon sx={{ fontSize: 40, color: colors.accent.cyan, mb: '12px' }} />
                <Typography variant="h5" sx={{ color: colors.text.primary, fontFamily: '"Orbitron", sans-serif', fontWeight: 700, mb: '8px' }}>
                    Follow to unlock Network Basics
                </Typography>
                <Typography sx={{ color: colors.text.secondary, maxWidth: 480, margin: '0 auto 20px' }}>
                    Follow @web3pwn on X to unlock this track's Network Basics stages.
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<TwitterIcon />}
                    onClick={handleFollow}
                    sx={{
                        borderColor: colors.accent.cyan,
                        color: colors.accent.cyan,
                        fontFamily: '"Orbitron", sans-serif',
                        '&:hover': { borderColor: colors.accent.cyan, backgroundColor: colors.accent.cyanGlow },
                    }}
                >
                    Follow @web3pwn to unlock
                </Button>
            </Box>
        </GlowCard>
    );
};

export default FollowGate;
